import '@mantine/core/styles.css';
import { createRoot } from 'react-dom/client';
import { MantineProvider, createTheme } from '@mantine/core';
import { App } from './App';

const theme = createTheme({
  fontFamily: '"Noto Sans TC", sans-serif',
  primaryColor: 'indigo',
});

createRoot(document.getElementById('root')!).render(
  <MantineProvider theme={theme} defaultColorScheme="light">
    <App />
  </MantineProvider>,
);
